// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "productpg/" + {"189":"page-mixAndMatch","404":"page-singleProduct","406":"deferred"}[chunkId] + "." + {"189":"183546c6feee47beda1c","404":"182936a6266df76fd4b0","406":"1671888e32c7a4e9143e"}[chunkId] + ".css";
};